import { ReactComponent as FlagIcon } from "./svg/vn-flag.svg";
import "../flag-icon.scss";

export const VNFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
